import React, {useState, useEffect} from "react";

import {Table} from "../../../common/table/Table";
import {retrieveAllChangeConcepts} from "../../../../services/ChangeConceptService";

export const ChangeConceptTable = ({context, setContext, navigateTo, showToaster, setSpinnerText}) => {

    const [changeConcepts, setChangeConcepts] = useState([]);

    useEffect(() => {
        setSpinnerText("Retrieving Change Concepts");
        const fetchData = async () => {
            const [data, error] = await retrieveAllChangeConcepts(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    setChangeConcepts(data.conceptVOList);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    const handleRowClick = (changeConcept) => {
        setContext((prevState) => ({
            ...prevState,
            selectedChangeConcept: changeConcept,
        }));
        navigateTo("changeConceptCapture");
    }

    const handleAddButtonClick = () => {
        setContext((prevState) => ({
            ...prevState,
            selectedChangeConcept: null,
        }));
        navigateTo("changeConceptCapture");
    }

    return (
        <div className="admin-table-container">
            <Table tableData={changeConcepts} searchEnabled={true} onRowClick={handleRowClick}
                   buttonText="Add Change Concept" onButtonClick={handleAddButtonClick}
                   hiddenColumns={["externalReference", "isDeleted", "created", "lastModified"]}/>
        </div>
    );
}
